import api from "../../config/axios";

export class ContactService {
    async postContact(data: {
        full_name: string;
        phone_no: string;
        email: string;
        issue: string;
        message: string;
    }) {
        const response = await api.post("/contact-us", data);
        return response.data;
    }
}
const contactService = new ContactService();
export default contactService;